import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'habil-cadastro-balanceamento',
  templateUrl: './cadastro-balanceamento.component.html',
  styleUrls: ['./cadastro-balanceamento.component.scss']
})
export class CadastroBalanceamentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
